var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAirtable = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4B927",
    fillRule: "evenodd",
    d: "M17.638 5.866 4.596 11.214a.863.863 0 0 0 .012 1.605l13.097 5.147a4.9 4.9 0 0 0 3.583 0l13.097-5.147a.863.863 0 0 0 .012-1.605L21.355 5.866a4.9 4.9 0 0 0-3.717 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4EA8D2",
    fillRule: "evenodd",
    d: "M20.658 20.776v12.857a.873.873 0 0 0 1.196.805l14.594-5.613A.87.87 0 0 0 37 28.02V15.163a.873.873 0 0 0-1.196-.805L21.21 19.97a.87.87 0 0 0-.552.805Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA3146",
    fillRule: "evenodd",
    d: "m17.976 20.673-4.69 2.232-8.989 4.244C3.727 27.42 3 27.011 3 26.387V14.588c0-.226.117-.42.275-.567a1 1 0 0 1 .217-.16.93.93 0 0 1 .782-.06l13.63 5.322c.693.271.748 1.228.072 1.55",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A02837",
    fillRule: "evenodd",
    d: "M3.686 13.741a1 1 0 0 0-.686.292l10.632 9.05 4.335-2.113a.86.86 0 0 0 .488-.782.89.89 0 0 0-.56-.834l-13.878-5.55a.9.9 0 0 0-.331-.063",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAirtable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/airtable.00cf49e7.svg";